import { render, staticRenderFns } from "./PCReceiveExport.vue?vue&type=template&id=cb8abc4c&"
import script from "./PCReceiveExport.vue?vue&type=script&lang=js&"
export * from "./PCReceiveExport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports